import { cn } from '@/lib/cn';

export function Progress({
  value,
  label,
  className,
}: {
  value: number;
  label: string;
  className?: string;
}) {
  const safeValue = Math.min(100, Math.max(0, value));
  return (
    <div
      className={cn('progress', className)}
      role="progressbar"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={safeValue}
    >
      <span className="progress__fill" style={{ inlineSize: `${safeValue}%` }} />
    </div>
  );
}
